import { TrackingV2Service } from '@api'
import { createEffect, createStore, sample } from 'effector'

import { mapAllChatterData } from '@/modules/tracking/chatter-tracking/utils.ts'
import { handleError } from '@/utils/error.ts'
import { dateToString } from '@/utils/helpers.ts'

export const findLeaderboardByDateFx = createEffect({
  name: 'find leaderboard by date',
  handler: async ({
    to,
    creatorIds,
    from,
  }: {
    from?: Date
    to?: Date
    creatorIds: Array<number>
  }) => {
    return creatorIds.length
      ? TrackingV2Service.findLeaderboard({
          from: dateToString(from || new Date()),
          to: dateToString(to || new Date()),
          creatorIds,
        })
      : {
          dataList: [],
          revenues: {},
          total: [],
        }
  },
})

findLeaderboardByDateFx.failData.watch((error) => {
  handleError(error, 'Failed to get chatter leaderboard data')
})

export const $allChatters = createStore<
  Nullable<ReturnType<typeof mapAllChatterData>>
>(null).on(findLeaderboardByDateFx.doneData, (_, data) =>
  mapAllChatterData(data),
)

let timeoutId = 0

export const resetRefreshStateFx = createEffect({
  name: 'refresh leaderboard data state reset',
  handler: () =>
    new Promise((resolve) => {
      if (timeoutId) {
        window.clearTimeout(timeoutId)
      }
      timeoutId = window.setTimeout(resolve, 10000)
    }),
})

export const $refreshAvailable = createStore(true)
  .on(findLeaderboardByDateFx, () => false)
  .reset(findLeaderboardByDateFx.failData, resetRefreshStateFx.doneData)

sample({
  clock: findLeaderboardByDateFx.doneData,
  target: resetRefreshStateFx,
})
